module.exports = __webpack_public_path__ + "img/155-Skai Woodec Sheffield Oak Alpine.jpg";